export default {
  namespaced: true,
  state: {
    sources: [
      'API'
    ]
  },
  getters: {
    sources: state => {
      return state.sources
    }
  }
}
